import { useNavigate, useParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { ShowController } from "./show-controller";
import { ShowPage } from "./show-page";

/** `/events/:eventId`. */
export function ShowRoute({ deps }: { deps: AppDeps }) {
  const navigate = useNavigate();
  const { eventId = "" } = useParams<{ eventId: string }>();
  return (
    <Subtree
      key="show"
      deps={[eventId]}
      controller={() =>
        new ShowController(
          pick(deps, "client", "authHandler", "storeRepository", "shareLinks"),
          { eventId },
          {
            toList: () => navigate("/events"),
            toEdit: (id) => navigate(`/events/${id}/edit`),
          },
        )
      }
    >
      <ShowPage />
    </Subtree>
  );
}
